export default "__VITE_ASSET__4YMCB1zo__"